import * as React from 'react';
import {Box, CircularProgress, Typography} from "@mui/material";
import {useGetProductAvailabilityQuery} from "../../core/api/products-api";
import PropTypes from "prop-types";
import {useEffect} from "react";

export default function GiftLocation(props) {
    const {data: response, isFetching, isSuccess} = useGetProductAvailabilityQuery({
        productId: props.productId,
        userSelectedLocation: props.receiverLocation
    })
    useEffect(() => {
        if (isSuccess && response) {
            props.setAvailability(response.availableInLocation);
        }
    }, [response])
    return (
        <Box sx={{mt: 2}}>
            {props.receiverLocation !== "" ?
                <Box>
                    {isFetching ?
                        <CircularProgress/> :
                        <Box>
                            {response && response.availableInLocation  ?
                                <Typography gutterBottom variant="body1" component="div">
                                    Delivery location : <b>{props.receiverLocation}</b>
                                </Typography> :
                                <Typography>
                                    The product is not available in your colleague's location
                                </Typography>
                            }
                        </Box>
                    }
                </Box> :
                <Box>
                    <Typography gutterBottom variant="body1" component="div">
                        Select a colleague to find out whether the gift can be delivered
                    </Typography>
                </Box>
            }
        </Box>
    );
}

GiftLocation.propTypes = {
    receiverLocation: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
    setAvailability: PropTypes.func.isRequired
};